import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid2,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { servicesUrl, serviceTypesUrl } from "../../../utils/urls";
import LoadingUI from "../../../components/LoadingUI";
import EmptyListUi from "../../../components/EmptyListUi";
import ServiceTypeConfigAccordionCard from "../../../components/pages/services/ServiceTypeConfigAccordionCard";
import PageHeader from "../../../components/page-layout/PageHeader";

const ServiceStep = ({ formData = {}, setFormData, onBack, nextStep }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedServices, setSelectedServices] = useState([]);

  useEffect(() => {
    if (formData.service) {
      setSelectedServices(formData.service);
    }
  }, [formData.services]);

  /**
   * Handles changes to a service type selection.
   * Adds or updates the selected service and its types in the selectedServices state.
   *
   * @param {Object} type - The service type object being changed.
   * @param {Object} service - The parent service object.
   * @param {any} value - The new value for the service type.
   */
  const onChangeService = (type, service, value, checked) => {
    // Find if the service is already selected
    const foundIndexOfService = selectedServices.findIndex(
      (s) => s.id === service.id
    );

    // If service is not selected, add it with the selected type
    if (foundIndexOfService === -1) {
      const newSelectedService = {
        id: service.id,
        name: service.name,
        types: [{ ...type, value }], // Add the selected type with its value
      };

      const updatedSelectedServices = [...selectedServices, newSelectedService];
      setSelectedServices(updatedSelectedServices);
    } else {
      // Service is already selected, update its types
      const foundService = selectedServices[foundIndexOfService];
      // Check if the type is already selected for this service
      const foundServiceTypeIndex = foundService.types.findIndex(
        (t) => t.id === type.id
      );

      if (foundServiceTypeIndex === -1) {
        // If type not found, add it to the types array
        foundService.types.push({ ...type, value });
      } else {
        if (checked === false)
          foundService.types = foundService.types.filter(
            (t) => t.id !== type.id
          );
        // If type exists, update its value
        else
          foundService.types = foundService.types.map((t) => {
            if (t.id === type.id) {
              const updatedType = { ...type };
              updatedType.value = value;
              return updatedType;
            }
            return t;
          });
      }

      // Update the selectedServices state with the modified service
      const updatedSelectedServices = selectedServices.map((s) => {
        if (s.id === foundService.id) return foundService;
        return s;
      });
      setSelectedServices(updatedSelectedServices);
    }
  };

  console.log({ selectedServices });
  selectedServices.forEach((service) => service.types.map(console.table));

  useEffect(() => {
    axiosInstance
      .get(servicesUrl)
      .then((svcRes) => {
        const svcData = Array.isArray(svcRes.data)
          ? svcRes.data
          : svcRes.data.data || [];
        
        const formatted = svcData.map((svc) => ({
          id: svc.id,
          name: svc.name.trim(),
          printPreference: svc.printPreference,
          isRequired: svc.isRequired,
          isDefault: svc.isDefault,
          description: svc.description,
          types: svc.service_types,
        }));

        // Sort services: default services first
        const sortedServices = formatted.sort((a, b) => {
          if (a.isDefault && !b.isDefault) return -1;
          if (!a.isDefault && b.isDefault) return 1;
          return 0;
        });

        setServices(sortedServices);

        // Auto-select default services with all their types
        const autoSelectedDefaults = sortedServices
          .filter((svc) => svc.isDefault)
          .map((svc) => ({
            id: svc.id,
            name: svc.name,
            types: svc.types.map((type) => ({
              ...type,
              value: 0, // Default price value
            })),
          }));

        // Merge with existing selected services (avoid duplicates)
        setSelectedServices((prev) => {
          const existingIds = prev.map((s) => s.id);
          const newDefaults = autoSelectedDefaults.filter(
            (s) => !existingIds.includes(s.id)
          );
          return [...prev, ...newDefaults];
        });
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box>
      <Box>
        <PageHeader
          title={"Store Services"}
          lead={
            "Select the services and their types that your store will offer. You can configure each service type as needed."
          }
        />

        <Stack gap={2} sx={{ px: 1 }}>
          {loading ? (
            <LoadingUI text="Loading services..." />
          ) : services.length === 0 ? (
            <EmptyListUi text="No services found. Ask Admin about this issue" />
          ) : (
            services.map((service) => {
              return (
                <ServiceTypeConfigAccordionCard
                  value={selectedServices.find((s) => s.id === service.id)}
                  onChangeService={onChangeService}
                  key={service.id}
                  service={service}
                />
              );
            })
          )}
        </Stack>
      </Box>

      <Stack gap={2} mt={2} flexDirection={"row"} justifyContent={"flex-end"}>
        <Button
          variant="outlined"
          size="small"
          disabled={!onBack}
          onClick={onBack}
        >
          Back
        </Button>

        <Button
          type="submit"
          variant="contained"
          onClick={() => {
            setFormData((prev) => ({ ...prev, service: selectedServices }));
            nextStep();
          }}
        >
          Save & Next
        </Button>
      </Stack>
    </Box>
  );
};

export default ServiceStep;
